import { render, staticRenderFns } from "./smartSingleElection.vue?vue&type=template&id=90626f3a&scoped=true&lang=html&"
import script from "./smartSingleElection.vue?vue&type=script&lang=js&"
export * from "./smartSingleElection.vue?vue&type=script&lang=js&"
import style0 from "./smartSingleElection.vue?vue&type=style&index=0&id=90626f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90626f3a",
  null
  
)

export default component.exports